import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DatePeriodService {

  private dateStartSubject: BehaviorSubject<any>
  private dateEndSubject: BehaviorSubject<any>
  private dateRangeSubject: BehaviorSubject<any>

  dateStart$: any
  dateEnd$: any
  dateRange$: any

  constructor() {

    this.dateStartSubject = new BehaviorSubject<Date>(null);
    this.dateEndSubject = new BehaviorSubject<Date>(null);
    this.dateRangeSubject = new BehaviorSubject<[Date, Date]>(null);

    this.dateStart$ = this.dateStartSubject.asObservable();
    this.dateEnd$ = this.dateEndSubject.asObservable();
    this.dateRange$ = this.dateRangeSubject.asObservable();

    this.setDefaultDate()
  }

  setDate(dateStart, dateEnd, dateRange){
    this.dateStartSubject.next(dateStart);
    this.dateEndSubject.next(dateEnd);
    this.dateRangeSubject.next(dateRange);
  }

  getDate(): { start: Date, end: Date , range: [Date, Date]} {
    return {
      start: this.dateStartSubject.value,
      end: this.dateEndSubject.value,
      range: this.dateRangeSubject.value
    };
  }

  setDefaultDate(){
    // Obtener la fecha actual
    const fechaActual = new Date();

    const startDate = new Date()
    startDate.setDate(fechaActual.getDate() - 7)

    this.dateStartSubject.next(startDate);
    this.dateEndSubject.next(fechaActual);
    this.dateRangeSubject.next([startDate, fechaActual]);

  }

  getFormatedDate(): {dateStart, dateEnd}{
    const minDate = this.formatDate(this.dateStartSubject.value)
    const endDate = this.formatDate(this.dateEndSubject.value)
    return {dateStart: minDate, dateEnd: endDate}
  }

  formatDate(selectedDate: Date): string {
    if (selectedDate && typeof selectedDate === 'object') {
      const day = selectedDate.getDate().toString().padStart(2, '0');
      const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
      const year = selectedDate.getFullYear().toString();

      return `${year}-${month}-${day}`;
    }

    if (selectedDate && typeof selectedDate === 'string') {
      const date = new Date(selectedDate);

      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear().toString();

      return `${year}-${month}-${day}`;
    }
  }
}
